/**
 * «Изменить условия» покупки: сумма, день, чем платить, до какой даты проверять.
 *
 * Условия правятся здесь, а пересчитывает их советник новым вопросом: так
 * в переписке видно, что именно поменяли, и ответ на новые условия стоит
 * отдельно от старого.
 */
import { useState } from 'react';
import { formatMoney, type Money, type PlainDate } from '@skoka/core';
import { DateButton } from '../date-picker.js';
import { SheetWrap } from '../sheet.js';
import type { AppState } from '../store.js';
import { dayMonth } from '../text.js';

export interface PurchaseTerms { amount: Money; date: PlainDate; card?: string }

/** Вопрос советнику по новым условиям — словами, как сказал бы человек. */
export function recheckQuestion(t: PurchaseTerms, until: 'month' | 'payment', state: AppState): string {
  const card = t.card ? state.accounts.find((a) => a.id === t.card) : undefined;
  const pay = card ? `с карты «${card.name}»` : 'со своих денег';
  const period = until === 'payment' && card ? ', проверь до дня платежа по карте' : ', проверь до конца месяца';
  return `Пересчитай: покупка ${formatMoney(t.amount)}, ${dayMonth(t.date, state.today)}, ${pay}${period}`;
}

export function ConditionsSheet({ state, value, onClose, onApply }: {
  state: AppState;
  value: PurchaseTerms;
  onClose: () => void;
  onApply: (question: string) => void;
}) {
  const cards = state.accounts.filter((a) => a.kind === 'credit_card' && !a.archived);
  const [rub, setRub] = useState(String(Math.round(value.amount / 100)));
  const [date, setDate] = useState<string>(value.date);
  const [card, setCard] = useState<string | undefined>(value.card);
  const [until, setUntil] = useState<'month' | 'payment'>('month');
  const amount = Math.round((Number(rub.replace(/\D/g, '')) || 0) * 100) as Money;
  const ok = amount > 0 && /^\d{4}-\d{2}-\d{2}$/.test(date);

  return (
    <SheetWrap title="Условия расчёта" onClose={onClose}>
      <div className="form chat-terms">
        <label className="chat-field">
          <span>Сумма покупки, ₽</span>
          <input inputMode="numeric" value={rub} onChange={(e) => setRub(e.target.value.replace(/[^\d\s]/g, ''))} />
        </label>
        <label className="chat-field">
          <span>Дата покупки</span>
          <DateButton label="Дата покупки" value={date} min={state.today} onChange={setDate} />
        </label>
        <div className="pick">
          <div className="k">Чем платить</div>
          <div className="chips">
            <button className={`chip${!card ? ' on' : ''}`} onClick={() => setCard(undefined)}>Свои деньги</button>
            {cards.map((c) => (
              <button key={c.id} className={`chip${card === c.id ? ' on' : ''}`} onClick={() => setCard(c.id)}>{c.name}</button>
            ))}
          </div>
        </div>
        {card && (
          <div className="pick">
            <div className="k">Проверить до</div>
            <div className="chips">
              <button className={`chip${until === 'month' ? ' on' : ''}`} onClick={() => setUntil('month')}>Конца месяца</button>
              <button className={`chip${until === 'payment' ? ' on' : ''}`} onClick={() => setUntil('payment')}>Платежа по карте</button>
            </div>
          </div>
        )}
        <button className="btn pri" disabled={!ok}
          onClick={() => onApply(recheckQuestion({ amount, date: date as PlainDate, ...(card ? { card } : {}) }, until, state))}>
          Пересчитать
        </button>
      </div>
    </SheetWrap>
  );
}
